@if (!production) {
  <div class="no-productive">Entorno no productivo</div>
}
<div class="body-content">
  <router-outlet />
</div>

